export type SaasDiscountType = "PERCENT" | "FIXED";
export type FreeTerminalMode = "NONE" | "COUNT" | "ALL";

export function saasDiscountAmount(planPrice: number, type: SaasDiscountType, value: number) {
  const price = Math.max(0, planPrice);
  if (type === "FIXED") return Math.min(price, Math.max(0, value));
  const percent = Math.min(100, Math.max(0, value));
  return (price * percent) / 100;
}

export function freeTerminalUnits(args: {
  terminalQuantity: number;
  linkFirstTerminalFree: boolean;
  mode?: FreeTerminalMode | null;
  freeTerminalCount?: number | null;
}) {
  const quantity = Math.max(0, args.terminalQuantity);
  const linkFree = args.linkFirstTerminalFree ? 1 : 0;
  if (args.mode === "ALL") return quantity;
  if (args.mode === "COUNT") {
    const promoFree = Math.max(0, args.freeTerminalCount ?? 0);
    return Math.min(quantity, Math.max(linkFree, promoFree));
  }
  return Math.min(quantity, linkFree);
}

export function terminalCharge(terminalQuantity: number, freeUnits: number, unitPrice: number) {
  return Math.max(0, terminalQuantity - freeUnits) * unitPrice;
}

export function formatSaasDiscountValue(type: SaasDiscountType, value: number) {
  if (type === "FIXED") return `$${value.toFixed(2)}`;
  return `${value}%`;
}

export function formatFreeTerminalSummary(mode: FreeTerminalMode, count: number) {
  if (mode === "ALL") return "All free";
  if (mode === "COUNT" && count > 0) return `${count} free`;
  return "—";
}

export function freeTerminalMessage(freeUnits: number, terminalQuantity: number) {
  if (freeUnits <= 0) return null;
  if (freeUnits >= terminalQuantity) return "All terminals are free!";
  if (freeUnits === 1) return "First terminal is free!";
  return `${freeUnits} terminals are free!`;
}
